export const OPENSEA_VAULT_URI = "https://opensea.io/the_vault";
export const NFTSTUDIOS_URI = "https://nftstudios.io/";

export const PREVIEW_ACCESS = "preview";
